export const experienceData = [
    {
        id: 1,
        company: 'Esgile',
        jobtitle: 'Graphic Web Designer',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        company: 'MUSHE GROUP',
        jobtitle: 'Web Developer',
        startYear: '2022',
        endYear: '2023'
    },
    {
        id: 3,
        company: 'Freelance Work',
        jobtitle: 'Freelance Graphic Designer / Web Developer',
        startYear: '2024',
        endYear: 'present'
    },
]